import { RecentlyOpenedEntityType } from '../enums'

export const getRecentlyOpenedEntitiesRequest = (amount: number) => ({
  method: 'GET',
  url: `/modules/recently-opened-entities/${amount}`
})

export const getRecentlyOpenedRequest = (amount: number, type: RecentlyOpenedEntityType) => ({
  url: `/modules/recently-opened-entities/${type}/${amount}`,
  method: 'GET'
})

export const putRecentlyOpenedRequest = (EntityType: RecentlyOpenedEntityType, EntityUUID: string) => ({
  url: '/modules/recently-opened-entities',
  method: 'PUT',
  data: {
    EntityType,
    EntityUUID
  }
})
